import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardContent, Grid, Fab, Typography, Box, Paper, Button, CircularProgress, Checkbox } from '@mui/material';
import { ModalDomicilio } from './ModalDomicilio';
import Swal from 'sweetalert2';

export const DomiciliosUsuarioRR = ({ datos, setDatos, bloquearBtn, setTituloModal, setTitulosSelect, setOpen, setTipoDomicilio, setDatosDocimilio, bloquearBtnEdit, setErrorTelefono, tipoCalleSelect, datosDocimilio, setDomiciliosProfesionales, domiciliosProfesionales, setMarcadores, setLocation}) => {
    const [openModalDomicilio, setOpenModalDomicilio] = useState(false);

    const handleOpen = TpoDomicilio => {

        // console.log("paso 1" ,datosDocimilio)

        setTitulosSelect({
            label: '', value: 0
        });

        setLocation({
            lat: -62.7113387,
            lng: -95.00657030000001,
        });

        setMarcadores([{
            lat: -62.7113387,
            lng: -95.00657030000001,
            time: new Date()
        }]);

        TpoDomicilio = Number(TpoDomicilio);
        setTituloModal(renderSwitch(TpoDomicilio));
        let paso = 0;

        //* Esta linea de codigo es el problema:  domicilio.TpoDomicilio === undefined
        datos.domicilios.map((domicilio, index) => {
            if ((domicilio.TpoDomicilio === TpoDomicilio || (domicilio.TpoDomicilio === undefined && domicilio.tpoDomicilio === TpoDomicilio) || domicilio.TpoDomicilio === 0) && paso === 0) {
                setDatosDocimilio({
                    TpoDomicilio: TpoDomicilio,
                    localidad: domicilio.localidad !== null ? domicilio.localidad : '',
                    codLocalidad: domicilio.codLocalidad !== undefined ? domicilio.codLocalidad : '',
                    calle: domicilio.calle,
                    numero: domicilio.numero.trim(),
                    piso: domicilio.piso.trim(),
                    depto: domicilio.depto.trim(),
                    tpoCalle: domicilio.tpoCalle !== undefined ? domicilio.tpoCalle : 0,
                    delegacion: domicilio.delegacion !== null ? domicilio.delegacion : '',
                    codPostal: domicilio.codPostal,
                    partido: domicilio.partido !== null ? domicilio.partido : '',
                    provincia: domicilio.provincia !== null ? domicilio.provincia : '',
                    telefono: domicilio.telefono.trim(),
                    caracteristica: domicilio.caracteristica !== null ? domicilio.caracteristica : '',
                    caracteristicaFijo: domicilio.caracteristicaFijo !== null ? domicilio.caracteristicaFijo : '',
                    celular: domicilio.celular.trim(),
                    tpoCarga: 1 
                });

                paso = 1;
                return setDatosDocimilio;
            }
        });

        // console.log("paso 2", datosDocimilio)
        setErrorTelefono({ display: "none" });
        setOpenModalDomicilio(true);
        setTipoDomicilio(Number(TpoDomicilio));
    };

    if (datos.domicilios[0].TpoDomicilio !== null && datos.domicilios[0].TpoDomicilio !== undefined && datos.domicilios[0].TpoDomicilio !== 0) {
        datos.domicilios.sort(function (a, b) {
            if (a.TpoDomicilio === null) {
            } else {
                if (a.TpoDomicilio > b.TpoDomicilio) {
                    return 1;
                }
                if (a.TpoDomicilio < b.TpoDomicilio) {
                    return -1;
                }
            }
            return 0;
        });
    }

    let estilo = {};
    const renderSwitch = param => {
        switch (param) {
            case 1:
                estilo = { marginRight: '-30%', marginLeft: "22%" };
                return 'Particular';
            case 2:
                estilo = { marginRight: '-22%', marginLeft: "22%" };
                return 'Profesional';
            case 3:
                estilo = { marginRight: '-20%', marginLeft: "25%" };
                return 'Constituido';
            case 4:
                estilo = { marginRight: '-25%', marginLeft: "12%" };
                return 'Correspondencia';
            case 5:
                estilo = { marginRight: '-25%', marginLeft: "25%" };
                return 'Real Caja';
        }
    };

    return (
        <>
            {datos.domicilios.map((domicilio, index) => (
                <Grid item md={2.4} xs={12} padding={2} >
                    <Card  sx={{height: '80%', boxShadow: 5, background: domicilio.confirmaDomicilio ? '#E1E1E1' : '#e4f0ec', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba'}}>
                        <CardContent sx={{padding:'5px'}}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <Grid  >
                                        <h3 style={{ marginTop: '1px', marginBottom: '1px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>  {
                                                (domicilio.TpoDomicilio !== undefined && domicilio.TpoDomicilio !== 0) &&
                                                renderSwitch(domicilio.TpoDomicilio)
                                            }
                                            {
                                                (domicilio.TpoDomicilio === undefined || domicilio.TpoDomicilio === 0) &&
                                                renderSwitch(Number(index + 1))
                                            }
                                        </h3>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {(localStorage.userType !== "1" && (bloquearBtn !== true)) &&
                                <Grid sx={{position: 'bottom', right: '22%',justifyContent:'flex-end',display:'flex' , mt: 1, mb:'1px' }}>
                                    <Grid >
                                    {(!domicilio.confirmaDomicilio) &&(
                                        <Button disabled={bloquearBtn} onClick={() => handleOpen(Number(index + 1))} variant="contained" color="secondary" size='small'sx={{ mr: 1 }} >
                                        Ingresar
                                        </Button>
                                    )}
                                    </Grid>
                                </Grid>
                            }
                            {(localStorage.userType === "1") &&
                                <Grid sx={{position: 'bottom', right: '22%',justifyContent:'flex-end',display:'flex' , mt: 1, mb:'1px' }}>
                                    <Grid >
                                        <Button  onClick={() => handleOpen(Number(index + 1))} variant="contained" color="secondary" size='small'sx={{ mr: 1 }} >
                                            Ingresar
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                        </CardContent>
                    </Card>
                </Grid>
            ))}
            {
                openModalDomicilio && 
                <ModalDomicilio datos={datos} setDatos={setDatos} open={openModalDomicilio} setOpenModalDomicilio={setOpenModalDomicilio} tipoCalleSelect={tipoCalleSelect} datosDocimilio = {datosDocimilio} bloquearBtn = {bloquearBtn} setTituloModal={setTituloModal} setDatosDocimilio={setDatosDocimilio} setErrorTelefono={setErrorTelefono} setOpen={setOpen} setTipoDomicilio={setTipoDomicilio} setDomiciliosProfesionales={setDomiciliosProfesionales} domiciliosProfesionales={domiciliosProfesionales}/>
            }
        </> 
    );
}